import ajax from '../http/ajax'

export const getWxConfig = data => {
    return ajax.get('wxconfig', data)
}
